import qs from "qs"

export const paramsSerializer = (params: any) => {
    return qs.stringify(params, {
        skipNulls: true,
        arrayFormat: "comma",
    })
}
